/** Plain display / prose name (Pascal case). Use `SiteNameWordmark` in UI for colored Jobs. */
export const SITE_NAME = "CaliJobs.dev";
export const SITE_TAGLINE =
  "Latest Software Engineer Jobs in California.";
